// ----------------- global Variables
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

window.portfolioAPP = window.portfolioAPP || {};
window.mainController = window.mainController || (new ScrollMagic.Controller({refreshInterval: 0}));
window.screenHeight = $(window).height();
window.arrayOffsets = [screenHeight, screenHeight * .1, screenHeight * .2, screenHeight * .3, screenHeight * .4, screenHeight * .5]

window.fixedSidebarLeftTop = 0;
window.fixedSidebarRightTop = 0;
window.fixedSidebarLeftDuration = 0;
window.fixedSidebarRightDuration= 0;

window.scenes = [];
window.y = 0;
window.scrollBar;

// Barba transition variables
window.lastElementClicked = '';
window.lastElementClickedId = '';
window.lastElementClickedClass = '';
// ----------------- global Variables


/*==========================================================================
        onInitialise
==========================================================================*/
portfolioAPP.onInitialise = function () {

  //-- lazyload 
  window.lazySizesConfig = window.lazySizesConfig || {};
  //add simple support for background images:
  document.addEventListener('lazybeforeunveil', function(e){

    let bg = e.target.getAttribute('data-bg');
    if(bg){
      let img = new Image();
      img.src = bg;
      let imgLoad = imagesLoaded(img, function() {
        //console.log('#container background image loaded');
      })
      imgLoad.on( 'done', function( instance ) {
        e.target.style.backgroundImage = 'url(' + img.src + ')';
      });
    }
  });

  var deviceAgent = navigator.userAgent.toLowerCase();
  var isTouchDevice = Modernizr.touch || 
  (deviceAgent.match(/(iphone|ipod|ipad)/) ||
  deviceAgent.match(/(android)/)  || 
  deviceAgent.match(/(iemobile)/) || 
  deviceAgent.match(/iphone/i) || 
  deviceAgent.match(/ipad/i) || 
  deviceAgent.match(/ipod/i) || 
  deviceAgent.match(/blackberry/i) || 
  deviceAgent.match(/bada/i));
  if (Modernizr.mq('only screen and (min-width:991px)')) {
    console.log('isDesktop')
    $('body').removeClass('touchDevice').addClass('desktop');
    return 'isLargeScreen'
  }else if (Modernizr.mq('only screen and (max-width:600px)')){
    if (isTouchDevice){
      console.log('isTouchDevice')
      $('body').removeClass('desktop').addClass('touchDevice');
      return 'isTouchDevice'
    }else{
      console.log('isLittleScreen')
      $('body').removeClass('touchDevice').addClass('littleScreen');
      return 'isTouchDevice'
    }
  }else {
    console.log('isDesktop')
    $('body').removeClass('touchDevice').addClass('desktop');
    return 'isDesktop'
  }

}
/*==========================================================================
        onInitialise
==========================================================================*/


/*==========================================================================
        Check screenOrientation
==========================================================================*/
portfolioAPP.screenOrientation = function () {
  screenWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
  screenHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
  $('body').addClass((screenWidth >= screenHeight) ? 'landscape' : 'portrait');

  //onResize
  $(window).on('resize', function () {
    $('.tabsMenuCopyWrap').height($('.tabsMenuCopy.active').height())
    screenWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
    screenHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
    $('body').removeClass('landscape portrait').addClass((screenWidth >= screenHeight) ? 'landscape' : 'portrait');
  });
}
/*==========================================================================
        Check screenOrientation
==========================================================================*/


/*==========================================================================
        SMOOTHSCROLL EFFECT
==========================================================================*/
portfolioAPP.smoothScroll = function () {

  var deviceAgent = navigator.userAgent.toLowerCase();
  var isTouchDevice = Modernizr.touch || 
  (deviceAgent.match(/(iphone|ipod|ipad)/) ||
  deviceAgent.match(/(android)/)  || 
  deviceAgent.match(/(iemobile)/) || 
  deviceAgent.match(/iphone/i) || 
  deviceAgent.match(/ipad/i) || 
  deviceAgent.match(/ipod/i) || 
  deviceAgent.match(/blackberry/i) || 
  deviceAgent.match(/bada/i));
  
  // initial smooth-scrollbar
  scrollBar = Scrollbar.init(
    document.querySelector("#smoothScrollWrap"), {
      // Momentum reduction damping factor, a float value between (0, 1)
      damping: (isTouchDevice)?.05:.25,
      // Minimal size for scrollbar thumb.
      thumbMinSize: 20,
      // Render scrolling by integer pixels
      renderByPixels: true,
      // Whether allow upper scrollable content to continue scrolling when current scrollbar reaches edge.
      // When set to 'auto', it will be enabled on nested scrollbars, and disabled on first-class scrollbars.
      continuousScrolling: 'auto',
      // Keep scrollbar tracks always visible.
      alwaysShowTracks: true,
      // Element to be used as a listener for mouse wheel scroll events.
      // By default, the container element is used.
      //wheelEventTarget: null,
      delegateTo: null,
      // execute listeners synchronously to make sure they can be rendered at same tick
      syncCallbacks: true,
      // plugins
      plugins: {}
    })

  // listener smooth-scrollbar, update controller
  scrollBar.addListener(function (status) {
    y = status.offset.y;
    scenes.forEach(function (scene) {
      scene.refresh();
    });
  });

}
/*==========================================================================
        SMOOTHSCROLL EFFECT
==========================================================================*/



/*==========================================================================
        Loader
==========================================================================*/
window.loader = {
  loaderImagesCounter: 0,
  totalImagesToLoad: $(".bgImagePreload, img.imagePreload").length,
  updateTxtPerc: function () {
    //console.log('Starting updateTxtPerc...');
    percIntroAnimation = Math.round(100 * this.progress());
    if ( "homePage" == $('body').attr( "data-currentPage") ) {
      $(".preloaderWrapHome .txt-perc").text(percIntroAnimation + "%")
      //$(".preloaderWrapHome #preloaderBG").css({ opacity: 1 })
      $(".preloaderWrapHome #preloader").css({
        opacity: 1,
        "-webkit-transform":"translate("+(-100+percIntroAnimation) + "vw, 0)",
        "-ms-transform":"translate("+(-100+percIntroAnimation) + "vw, 0)",
        "transform":"translate("+(-100+percIntroAnimation) + "vw, 0)"
      })
    } else {
      $(".preloaderWrapProjects .txt-perc").text(percIntroAnimation + "%")
      //$(".preloaderWrapProjects #preloaderBG").css({ opacity: 1 })
      $(".preloaderWrapProjects #preloader").css({
        opacity: 1,
        "-webkit-transform":"translate("+(-100+percIntroAnimation) + "vw, 0)",
        "-ms-transform":"translate("+(-100+percIntroAnimation) + "vw, 0)",
        "transform":"translate("+(-100+percIntroAnimation) + "vw, 0)"
      })
    }
  },
  removeLoader: function () {
    //console.log('Starting removeLoader...');
    // Unlock body scroll when loader is removed
    enableBodyScroll(document.body);
    enableBodyScroll(document.documentElement);
    
    // Also unlock smooth-scrollbar container if it exists
    const smoothScrollWrap = document.querySelector("#smoothScrollWrap");
    if (smoothScrollWrap) {
      enableBodyScroll(smoothScrollWrap);
    }
    
    // Re-enable smooth-scrollbar if it exists
    if (window.scrollBar && typeof window.scrollBar.update === 'function') {
      window.scrollBar.update();
      // Clear locked position
      if (window.scrollBar._lockedPosition !== undefined) {
        delete window.scrollBar._lockedPosition;
      }
    }
    
    // Remove scroll event handlers from preloader
    const preloaderWrap = document.querySelector('.preloaderWrap');
    if (preloaderWrap && preloaderWrap._scrollLockHandlers) {
      const preventScroll = preloaderWrap._scrollLockHandlers;
      preloaderWrap.removeEventListener('wheel', preventScroll);
      preloaderWrap.removeEventListener('touchmove', preventScroll);
      preloaderWrap.removeEventListener('scroll', preventScroll);
      delete preloaderWrap._scrollLockHandlers;
    }
    
    var removeLoader = new TimelineMax;
    if ( "homePage" == $('body').attr( "data-currentPage") ) {
      return removeLoader
      .to($(".preloaderWrapHome .txt-perc"), .3, {x: 100,autoAlpha: 0,ease: Back.easeIn}, .1)
      .set($(".preloaderWrap #preloaderBG"), {className: "+=is-hidden"})
      .set($("body"), {className: "-=is-loading"})
      .set($("html"), {className: "-=is-loading"})
      .set($("#about"), {className: "+=is-loaded"})
      .set($(".preloaderWrap"), {className: "+=is-hidden"})
    } else {
      return removeLoader
      .to($(".preloaderWrapProjects .txt-perc"), .3, {x: 100,autoAlpha: 0,ease: Back.easeIn}, .1)
      .set($(".preloaderWrap #preloaderBG"), {className: "+=is-hidden"})
      .set($("body"), {className: "-=is-loading"})
      .set($("html"), {className: "-=is-loading"})
      .set($("#about"), {className: "+=is-loaded"})
      .set($(".preloaderWrap"), {className: "+=is-hidden"})
    }
  },
  imagesLoader: function () {
    // Lock body scroll when loader starts
    disableBodyScroll(document.body);
    
    // Also lock smooth-scrollbar container if it exists
    const smoothScrollWrap = document.querySelector("#smoothScrollWrap");
    if (smoothScrollWrap) {
      disableBodyScroll(smoothScrollWrap);
    }
    
    // Also lock html element
    disableBodyScroll(document.documentElement);
    
    // Disable smooth-scrollbar if it exists
    if (window.scrollBar && typeof window.scrollBar.update === 'function') {
      // Store original scroll position
      if (!window.scrollBar._lockedPosition) {
        window.scrollBar._lockedPosition = window.scrollBar.offset.y;
      }
      // Prevent scrolling
      window.scrollBar.setPosition(0, window.scrollBar._lockedPosition || 0);
    }
    
    // Prevent scroll events on preloader wrapper
    const preloaderWrap = document.querySelector('.preloaderWrap');
    if (preloaderWrap) {
      const preventScroll = function(e) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      };
      preloaderWrap.addEventListener('wheel', preventScroll, { passive: false });
      preloaderWrap.addEventListener('touchmove', preventScroll, { passive: false });
      preloaderWrap.addEventListener('scroll', preventScroll, { passive: false });
      // Store handler for cleanup
      preloaderWrap._scrollLockHandlers = preventScroll;
    }
    
    let introAnimation = new TimelineMax({
      paused: true,
      onUpdate: this.updateTxtPerc,
      onComplete: this.removeLoader
    })
    let loaderImagesCounter = this.loaderImagesCounter
    let totalImagesToLoad = this.totalImagesToLoad

    $(".bgImagePreload, img.imagePreload").imagesLoaded({
        background: !0
      })
      .always(function () {
        if ( "projectsPage" == $('body').attr( "data-currentPage") ) {
          portfolioAPP.initialiseProjects()
        }
      })
      .done(function () {
        //console.log('all images successfully loaded');
      })
      .fail(function () {
        //console.log('all images loaded, at least one is broken');
      })
      .progress(function (instance, image) {
        var result = image.isLoaded ? 'loaded' : 'broken';
        //console.log( 'image is ' + result + ' for ' + image.img.src );   
        loaderImagesCounter++;
        percLoadedImages = loaderImagesCounter / totalImagesToLoad;
        TweenLite.to(introAnimation, .7, {
          progress: percLoadedImages,
          ease: Linear.easeNone
        })
      });

    return introAnimation

  }
}
/*==========================================================================
        Loader
==========================================================================*/




document.addEventListener('DOMContentLoaded', function () {
  // Lock body scroll if loader is already active (body has is-loading class)
  if (document.body.classList.contains('is-loading')) {
    // Add class to html as well for CSS targeting
    document.documentElement.classList.add('is-loading');
    
    disableBodyScroll(document.body);
    disableBodyScroll(document.documentElement);
    
    // Also lock smooth-scrollbar container if it exists
    const smoothScrollWrap = document.querySelector("#smoothScrollWrap");
    if (smoothScrollWrap) {
      disableBodyScroll(smoothScrollWrap);
    }
    
    // Prevent scroll events on preloader wrapper
    const preloaderWrap = document.querySelector('.preloaderWrap');
    if (preloaderWrap) {
      const preventScroll = function(e) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      };
      preloaderWrap.addEventListener('wheel', preventScroll, { passive: false });
      preloaderWrap.addEventListener('touchmove', preventScroll, { passive: false });
      preloaderWrap.addEventListener('scroll', preventScroll, { passive: false });
      preloaderWrap._scrollLockHandlers = preventScroll;
    }
  }
  
  portfolioAPP.barba()
});
